import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './Collection.css';

// Separate component for mobile collection items
const MobileCollectionItem = ({ collection }) => {
  // Using multiple thresholds to track when element enters, centers, and leaves view
  const { ref, inView, entry } = useInView({
    threshold: [0, 0.30, 0.5, 0.75, 1],
    triggerOnce: false,
  });

  // Calculate how centered the element is
  const getScale = () => {
    if (!entry || !inView) return 1;
    
    // Get the element's position relative to viewport
    const windowHeight = window.innerHeight;
    const elementHeight = entry.boundingClientRect.height;
    const elementTop = entry.boundingClientRect.top;
    
    // Calculate the center points
    const elementCenter = elementTop + elementHeight / 2;
    const windowCenter = windowHeight / 2;
    
    // Calculate how far from center (0 means at center, 1 means at edge)
    const distanceFromCenter = Math.abs(elementCenter - windowCenter) / (windowHeight / 2);
    
    // Calculate scale based on distance from center
    // Max scale of 1.1 at center, minimum scale of 0.95 at edges
    const scale = Math.max(0.95, 1.1 - (distanceFromCenter * 0.15));
    
    return scale;
  };

  return (
    <div 
      ref={ref} 
      className={`mobile-item ${inView ? 'visible' : 'invisible'}`}
      style={{
        transform: `scale(${getScale()})`,
        opacity: inView ? 1 : 0
      }}
    >
      <div className="image-container">
        <img src={collection.imageUrl} alt={collection.name} className="image" />
        <div className="overlay" />
        <div className="content">
          <h3 className="title">{collection.name}</h3>
          <button
            onClick={() => (window.location.href = `/collections/${collection.id}`)}
            className="explore-button"
          >
            Explore Collection
          </button>
        </div>
      </div>
    </div>
  );
};

const Collection = ({ collections }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { ref: sectionRef, inView } = useInView({
    threshold: 0.2,
    triggerOnce: false,
  });

  return (
    <section ref={sectionRef} className={`collection-section ${inView ? 'visible' : 'invisible'}`}>
      <div className="collection-container">
        {/* Desktop Layout */}
        <div className="desktop-grid">
          {collections?.map((collection, index) => (
            <div
              key={collection.id}
              className={`collection-item ${inView ? 'scale-normal' : 'scale-small'} ${
                hoveredIndex === index ? 'hovered' : ''
              }`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="image-container">
                <img src={collection.imageUrl} alt={collection.name} className="image" />
                <div className="overlay" />
                <div className="content">
                  <h3 className="title">{collection.name}</h3>
                  <button
                    onClick={() => (window.location.href = `/collections/${collection.id}`)}
                    className="explore-button"
                  >
                    Explore Collection
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Mobile Layout */}
        <div className="mobile-layout">
          {collections?.map((collection) => (
            <MobileCollectionItem key={collection.id} collection={collection} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Collection;